'use client';

// eslint-disable-next-line local-rules/page-boundary-imports
import CityHeader from '@/vm/CityHeader';
import InternalLinkMod from '@/vm/InternalLinkMod';
import LocationInfo from '@/vm/LocationInfo';
import SplitHero from '@/vm/SplitHero';
import StepsSection from '~/components/vm/StepsSection';
import type { VendingMachineLocation } from '~/contracts/vm';

type LocationContainerProps = {
  city: string;
  state: string;
  vendingMachine: VendingMachineLocation;
  vendingMachineLocations: VendingMachineLocation[];
};

export default function LocationContainer({
  city,
  state,
  vendingMachine,
  vendingMachineLocations
}: LocationContainerProps) {
  return (
    <div className="pt-40">
      <CityHeader city={city} state={state} />
      <SplitHero
        vendingMachine={vendingMachine}
        vendingMachineLocations={vendingMachineLocations}
      />
      <LocationInfo vendingMachine={vendingMachine} />
      <StepsSection />
      <InternalLinkMod />
    </div>
  );
}
